<div class="settings__block">
  <h4 class="body-1 settings__title">
    <span>{{ 'INPUT_NAME.QUERY' | translate }}</span>
  </h4>
  <base-form-input [control]="controls?.cql" [hideLabel]="true" [placeholder]="'INPUT_NAME.QUERY' | translate"></base-form-input>
</div>
<mat-divider></mat-divider>
